import { render, staticRenderFns } from "./ImportarExportarCadastrosImport.vue?vue&type=template&id=31979182"
import script from "./ImportarExportarCadastrosImport.vue?vue&type=script&lang=js"
export * from "./ImportarExportarCadastrosImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports